import React from 'react'

import App from '../App.css'
import NavbarTemplate from '../Components/NavbarComponent'

import { SgdsMasthead } from '@govtechsg/sgds-masthead-react'

import '@govtechsg/sgds/css/sgds.css'

import OneMapLogoFooter from '../images/OM2_LOGO_white.png'

const HeaderRegComponent = () => {
  return (
    <>
    <div className="om-body-header container-fluid fixed-top">
        <div className="om-body-gov-banner">
          <div className="pageBase">
            <SgdsMasthead fluid />
          </div>
        </div>

        <div className="om-api-updates">
          <div className="gradient-banner"></div>
          <div className="om-api-text">
            <b style={{"color":"#F5333F"}}>IMPORTANT:</b><b> Search API</b> now requires token-based authentication. <a href="/apidocs/register">Register your token to ensure uninterrupted service.</a>
          </div>

        </div>

        <div className="pageBase">
          <div className="om-container-fluid-padding">
            <NavbarTemplate />
          </div>
        </div>
      </div>
    </>
  )
}
export default HeaderRegComponent
